import React from 'react';
import './SizeGuideModal.css';

function SizeGuideModal({ onClose }) {
  return (
    <div className="sg-backdrop" onClick={onClose}>
      <div className="sg-modal" onClick={(e) => e.stopPropagation()}>
        <button className="sg-close" onClick={onClose}>
          ×
        </button>
        <div className="sg-content">
          <h2>Size Guide</h2>
          <div className="sg-images">
            <img src="/assets/size/size-guide-1.jpg" alt="Size Guide - Overview" />
            <img src="/assets/size/size-guide-tee.jpg" alt="Size Guide - Tops and Bottoms" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SizeGuideModal;
